// ** React Imports
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// actiob for data fetching
import { getEpisodesByTag } from "@src/redux/action/planning/EpisodeAction.js";
import { getTagBySlug } from "@src/redux/action/planning/EmissionAction.js";
import FilterBlog from "./FilterBlog";
import Episodes from "./Episodes";
import "@styles/base/pages/app-ecommerce.scss";

const EpisodesByTag = () => {
  // ** States
  const [activeView, setActiveView] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [tagName, setTagName] = useState("");

  //paramsData
  const { slug } = useParams();

  // ** Vars
  const dispatch = useDispatch();
  const store = useSelector((state) => state.emissions);
  // data fetching use effect
  useEffect(() => {
    getEpisodesByTag(slug, dispatch, currentPage, perPage);
  }, [dispatch, currentPage, slug]);

  //header data fetching

  useEffect(async () => {
    const TagNameBySlug = await getTagBySlug(slug);
    setTagName(TagNameBySlug);
  }, [slug]);

  const { t } = useTranslation();

  // data from sotre
  const episodesByTag = useSelector((state) => state.episodes.episodesByTag);
  const EpisodeLastPage = useSelector(
    (state) => state.episodes.episodeLastPage
  );

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("EPISODES WITH TAG") + ` : ${tagName.name}`}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Emissions
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-part">
        <div className="container__video">
          <div className="row content-reverse">
            <FilterBlog t={t} />
            <div className="ecommerce-application col-lg-9">
              <Episodes
                store={store}
                data={episodesByTag}
                activeView={activeView}
                setActiveView={setActiveView}
                setCurrentPage={setCurrentPage}
                EpisodeLastPage={EpisodeLastPage}
                t={t}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default EpisodesByTag;
